import { initContract } from "@ts-rest/core";
import { z } from "zod";

const c = initContract();

const errorSchema = z.object({ statusCode: z.number(), message: z.string() });

export const BillingHealthSchema = z.object({
  checkedAt: z.string(),
  killbill: z.object({
    reachable: z.boolean(),
    latencyMs: z.number().nullable(),
    error: z.string().nullable(),
  }),
  webhook: z.object({
    expectedUrl: z.string().nullable(),
    registeredUrls: z.array(z.string()),
    registrationOk: z.boolean(),
    registrationStatus: z.enum(["ok", "missing", "mismatch", "not-configured", "unknown"]),
    registrationDetail: z.string(),
    lastReceived: z
      .object({
        eventType: z.string(),
        objectType: z.string().nullable(),
        objectId: z.string().nullable(),
        receivedAt: z.string(),
      })
      .nullable(),
    secondsSinceLast: z.number().nullable(),
  }),
  catalog: z.object({
    publishedVersions: z.number(),
    latestEffectiveDate: z.string().nullable(),
    error: z.string().nullable(),
  }),
  accounts: z.object({
    franchiseKbAccountCount: z.number(),
    bundleCount: z.number(),
  }),
  events: z.object({
    lastEventAt: z.string().nullable(),
    lastEventType: z.string().nullable(),
    countsByType: z.record(z.string(), z.number()),
    listenerCount: z.number(),
  }),
});

export type BillingHealth = z.infer<typeof BillingHealthSchema>;

export const billingHealthContract = c.router({
  getHealth: {
    method: "GET",
    path: "/billing/health",
    responses: {
      200: BillingHealthSchema,
      401: errorSchema,
      500: errorSchema,
    },
    summary: "Billing/KB health check (admin diagnostic)",
  },
});
